import client from "./client";

// 회원가입
export const register = data => client.post("/api/register/write", data);

// 이메일 중복체크
export const mailDuplicate = mail =>
  client.post("/api/register/emailCheck", mail);
